// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xYglI","footer":"styles_footer__236kb"};